import React, {useEffect, useState, useRef} from 'react';
import {t} from 'react-switch-lang';
import Swal from 'sweetalert2';
import {Empty, Form, Table} from 'antd';
import http from '../../../../services/httpService';
import {Spinner} from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useForm} from 'antd/lib/form/Form';
const returnValueWithAddon = (value, addOn, isBefore = true) => {
  return value && String(value)?.length > 0
    ? `${isBefore ? addOn : ''}${value}${!isBefore ? addOn : ''}`
    : '';
};
const ExternalizationTable = ({api, query, sort,
                                rows = 20, onClickRow,
                                cycleId,
                                apiAddon,
                                prefixCls,
                                columns,
                                ...rest}) => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(0);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = useForm();
  const [validateTrigger, setValidateTrigger] = useState();
  const [sortFilter, setSortFilter] = useState('');
  useEffect(() => {
    const fetchInitialData = async () => {
      setPage(0);
      setItems([]);
      try {
        const { data } = await http.get(
          cycleId
            ? `${api}?cycleId.equals=${cycleId}&page=0&size=${rows}${
              query ? `&${query}` : ''
            }${sortFilter ? `&${sortFilter}` : `&${sort}`}${returnValueWithAddon(
              apiAddon,
              '&'
            )}`
            : `${api}?page=0&size=${rows}${query ? `&${query}` : ''}${
              sortFilter ? `&${sortFilter}` : `&${sort}`
            }${returnValueWithAddon(apiAddon, '&')}`
        );
        setItems(data);
        setHasMore(data?.length === rows);
        setPage(1);
      } catch (err) {
        Swal.fire({
          text: `${t("message.errorApi")}`,
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    };
    fetchInitialData();
  }, [query, apiAddon, sortFilter, cycleId]);

  const fetchMoreData = async () => {
    try {
      const { data } = await http.get(
        cycleId
          ? `${api}?cycleId.equals=${cycleId}&page=${page}&size=${rows}${
            query ? `&${query}` : ''
          }${sortFilter ? `&${sortFilter}` : `&${sort}`}${returnValueWithAddon(
            apiAddon,
            '&'
          )}`
          : `${api}?page=${page}&size=${rows}${query ? `&${query}` : ''}${
            sortFilter ? `&${sortFilter}` : `&${sort}`
          }${returnValueWithAddon(apiAddon, '&')}`
      );

      setItems(prev => [...prev, ...data]);
      setHasMore(data?.length === rows);
      setPage(prev => prev + 1);
    } catch (err) {}
  };


  const onTableChange = (pagination, filters, sorter) => {
    if (sorter?.column) {
      setSortFilter(
        `sort=${sorter?.columnKey},${
          sorter.order === 'ascend' ? 'ASC' : 'DESC'
        }`
      );
    } else {
      setSortFilter('');
    }
  };

  const loader = (
    <div className="text-center mt-3">
      <Spinner variant="primary" animation="border" />
    </div>
  );
    return (
      <div style={{paddingBottom: '50px'}}>
        <InfiniteScroll
          next={fetchMoreData}
          hasMore={hasMore}
          loader={loader}
          scrollableTarget="app-body"
          dataLength={items?.length}
        >
          <Form
            form={form}
            validateTrigger={validateTrigger}
            onFinishFailed={() => {
              setValidateTrigger('onChange');
              form.validateFields(Object.keys(editingRecord));
            }}
          >
            <Table
              onChange={onTableChange}
              locale={{
                emptyText: (
                  <Empty
                    description={t('common.noData')}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
                triggerAsc: t('common.ascending'),
                triggerDesc: t('common.descending'),
                cancelSort: t('common.cancelSort'),
              }}
              columns={columns}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    onClickRow(record?.id);
                  }, // click row
                };
              }}
              prefixCls={prefixCls}
              dataSource={items}
              sticky={true}
              pagination={false}
            />
          </Form>
        </InfiniteScroll>
      </div>
    );
};

export default ExternalizationTable;
